import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//@mui
import { Box } from '@mui/material';
//components
import CostSummary from '../../../components/projectmng/costcalc/CostSummary';
import CostCalcLockList from '../../../components/projectmng/costcalc/CostCalcLockList';
import { listProjectCosts } from '../../../modules/projectModule/projectCosts';

const CostCalcLockContainer = () => {
  const dispatch = useDispatch();
  const { project, costs } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
    costs: projectModule.projectCosts.costs,
  }));

  useEffect(() => {
    if (project) {
      dispatch(listProjectCosts(project.prjUuid));
    }
  }, [project]);

  // [추가] 매입처별로 정렬하는 로직
  // sellPartnerUuid가 같은 데이터끼리 뭉쳐야 소계 로직이 정확히 작동합니다.
  const sortedCosts = useMemo(() => {
    if (!costs) return [];
    
    return [...costs].sort((a, b) => {
      const nameA = a.sellPartnerNm || '';
      const nameB = b.sellPartnerNm || '';
      // 매입처명 가나다순으로 정렬 (동일 매입처끼리 묶임)
      return nameA.localeCompare(nameB);
    });
  }, [costs]);

  return (
    <Box>
      {/*
      <Box sx={{ py: 1 }}>
        <CostSummary project={project} costsVat={sortedCosts}/>
      </Box>
       */}
      <Box sx={{ py: 1 }}>
        {sortedCosts.length > 0 && <CostCalcLockList costs={sortedCosts} />}
      </Box>
    </Box>
  );
};

export default CostCalcLockContainer;
